import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from '../service/config.service';
import { SessionService } from '../service/session.service';

@Injectable({
  providedIn: 'root',
})
export class InvoiceAccessGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly configService: ConfigService,
    private readonly sessionService: SessionService,
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.configService
      .whenResolved()
      .pipe(map((config) => this.decideAccess(config, state.url)));
  }

  private decideAccess(config: any, url: string): boolean | UrlTree {
    if (!this.isInvoiceFeatureEnabled(config)) {
      return this.router.createUrlTree(['/404']);
    }

    if (this.sessionService.canSubmitInvoice()) {
      return true;
    }

    return this.router.createUrlTree(['login'], {
      queryParams: {
        redirect: 'invoice',
        returnUrl: url,
      },
    });
  }

  private isInvoiceFeatureEnabled(config: any): boolean {
    const featureEnabledValue = config?.invoiceFeatureEnabled;

    if (
      featureEnabledValue === null ||
      featureEnabledValue === undefined ||
      featureEnabledValue === ''
    ) {
      return true;
    }

    return featureEnabledValue.toString().toLowerCase() === 'true';
  }
}
